<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--차량정보-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001353') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--제품 ID-->
							<th class="col-1">* {{ getMessage_('QWCC001538') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="pmcId"
												class="inputWithIcon"
												maxlength="20"
												@keyup.native.delete="onPmcIdInuPutKeyDown()"
												@change="onPmcIdInuPutKeyDown"
												:readonly="roApcnPopUp.readOnlyAuth"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onPmcPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<th class="col-1">Vin No.</th>
							<td class="col-1"><el-input v-model="carVin" readonly /></td>
							<!--연료전지사양-->
							<!-- <th class="col-1">{{ getMessage_('QWCC001021') }}</th>
							<td class="col-1"><el-input v-model="flclSpcNm" readonly /></td> -->
							<!--차량유형-->
							<th class="col-1">{{ getMessage_('QWCC001016') }}</th>
							<td class="col-1"><el-input v-model="carTypeNm" readonly /></td>

							<!--HTWO판매일-->
							<th class="col-1">{{ getMessage_('QWCC001044') }}</th>
							<td class="col-1">
								<el-input v-model="erpSaleDd" readonly />
							</td>
							<!--고객사 판매일-->
							<th class="col-1">{{ getMessage_('QWCC001047') }}</th>
							<td class="col-1">
								<el-input v-model="oemSaleDd" readonly />
							</td>
						</tr>
						<tr>
							<!--판매사-->
							<!-- <th class="col-1">{{ getMessage_('QWCC001045') }}</th>
							<td class="col-1"><el-input v-model="custNm" readonly /></td> -->
							<!--판매지역-->
							<th class="col-1">{{ getMessage_('QWCC001019') }}</th>
							<td class="col-1">
								<el-input v-model="saleRegnNm" readonly />
							</td>
							<!-- 质保起始日-->
							<th class="col-1">{{ getMessage_('QWCC002102') }}</th>
							<td class="col-1">
								<el-input v-model="wrntStrtDd" readonly />
							</td>
							<!--보증기간(년)-->
							<th class="col-1">{{ getMessage_('QWCC001351') }}</th>
							<td class="col-1">
								<el-input v-model="usePrdPo" readonly />
							</td>
							<!--보증거리-->
							<th class="col-1">{{ getMessage_('QWCC001023') }}</th>
							<td class="col-1">
								<el-input v-model="milgPo" readonly />
							</td>
							
							<!--보증만료일-->
							<th class="col-1">{{ getMessage_('QWCC002009') }}</th>
							<td class="col-1">
								<el-input v-model="wrntEndDd" readonly />
							</td>
<!-- 							
							<td class="col-1">
								<el-input v-model="jvSaleDd" hidden />
							</td> -->
						</tr>
						<tr>
							<th class="col-1">{{ getMessage_('QWCC002119') }}</th>
							<td class="col-1">
								<el-input v-model="licensePlate" readonly />
							</td>
							<th class="col-1">{{ getMessage_('QWCC001013') }}</th>
							<td class="col-1">
								<el-input v-model="custNm" readonly />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import
export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam5: { type: Object }
	},
	components: {},
	data() {
		return {
			carVin: '', // 차대번호
			pmcId: '', //PMC ID
			vehlNm: '', //차종명
			vehlCd: '', //차종코드
			carTypeNm: '', //차종유형
			erpSaleDd: '', //HTWO판매일
			custNm: '', //판매사
			saleRegnNm: '', //판매지역
			flclSpcNm: '', //연료전지사양
			usePrdPo: '', //보증사용기간
			milgPo: '', //보증주행거리
			oemSaleDd: '', //고객사판매일
			pmcNoInput: '',
			licensePlate: '',

			wrntStrtDd: '', //품질보증 시작일
			wrntEndDd: '' //보증만료일
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onPmcPopup() {
			if (this.roApcnPopUp.readOnlyAuth == false) {
				this.pmcNoInput = this.pmcId;

				/*현상팝업*/
				this.$emit('OpenPmcPopup', this.pmcNoInput);
			}
		},
		onPmcIdInuPutKeyDown() {
			//console.log('값은>>>>>>', this.roApcnPopUp.readOnlyAuth);
			if (this.roApcnPopUp.readOnlyAuth == false) {
				// 지웠을때 실행함
				this.carVin = '';
				this.pmcId = '';
				this.vehlNm = '';
				this.vehlCd = '';
				this.custNm = '';
				this.licensePlate = '';
				this.carTypeNm = '';
				this.saleRegnNm = '';
				this.erpSaleDd = '';
				this.milgPo = '';
				this.usePrdPo = '';
				this.flclSpcNm = '';
				this.oemSaleDd = '';
				this.wrntStrtDd = '';
				this.wrntEndDd = '';
				this.setState_({ key: 'selectedPmcId', value: '' }); //PMC ID

				this.setStateRoApcnPopup_({ key: 'oemSaleDd', value: '' }); //고객판매일

				this.setState_({ key: 'isDelCeqDtCompInitFlag', value: true });
			}
		},
		setProcessInfo() {
			this.carVin = this.roApcnPopUp.carVin; // Vin No
			this.pmcId = this.roApcnPopUp.pmcId; //pmc 번호
			//this.vehlNm = this.roApcnPopUp.vehlNm; //차종명
			this.vehlNm = this.roApcnPopUp.vehlCd; //차종명
			this.vehlCd = this.roApcnPopUp.vehlCd; //차종코드
			this.carTypeNm = this.roApcnPopUp.carTypeNm; //차종유형

			this.custNm = this.roApcnPopUp.custNm; //판매사
			this.licensePlate = this.roApcnPopUp.licensePlate;
			this.saleRegnNm = this.roApcnPopUp.saleRegnNm; //판매지역

			this.erpSaleDd = this.roApcnPopUp.erpSaleDd; //HTWO판매일

			this.wrntStrtDd = this.roApcnPopUp.wrntStrtDd; //품질보증 시작일
			this.wrntEndDd = this.roApcnPopUp.wrntEndDd; //보증만료일

			this.milgPo = this.roApcnPopUp.milgPo; //보증주행거리
			this.usePrdPo = this.roApcnPopUp.usePrdPo; //보증사용기간

			this.flclSpcNm = this.roApcnPopUp.flclSpcNm; //연료전지사양
			this.oemSaleDd = this.roApcnPopUp.oemSaleDd; //고객판매일
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.
		if(this.roApcnPopUp.oemSaleDd!=null){
				this.carVin = this.roApcnPopUp.carVin; // Vin No

				this.carTypeNm = this.roApcnPopUp.carTypeNm; //차종유형

				this.custNm = this.roApcnPopUp.custNm; //판매사
				this.licensePlate = this.roApcnPopUp.licensePlate;
				this.saleRegnNm = this.roApcnPopUp.saleRegnNm; //판매지역
				this.oemSaleDd = this.roApcnPopUp.oemSaleDd; //고객판매일
				
				this.wrntStrtDd = this.roApcnPopUp.wrntStrtDd; //품질보증 시작일
				this.wrntEndDd = this.roApcnPopUp.wrntEndDd; //보증만료일

				this.milgPo = this.roApcnPopUp.milgPo; //보증주행거리
				this.usePrdPo = this.roApcnPopUp.usePrdPo; //보증사용기간
			}else{
				this.carVin = ""; // Vin No

				this.carTypeNm = ""; //차종유형

				this.custNm = ""; //판매사
				this.licensePlate = '';
				this.saleRegnNm = ""; //판매지역
				this.oemSaleDd = ""; //고객판매일
				

				this.milgPo = ""; //보증주행거리
				this.usePrdPo = ""; //보증사용기간

				this.wrntStrtDd = '';//품질보증 시작일
				this.wrntEndDd = '';//보증만료일
			}
			
		
		    this.pmcId = this.roApcnPopUp.pmcId; //pmc 번호
			this.flclSpcNm = this.roApcnPopUp.flclSpcNm; //연료전지사양
			this.erpSaleDd = this.roApcnPopUp.erpSaleDd; //HTWO판매일
			this.jvSaleDd = this.sendParam5.jvSaleDd; 
			this.jvCpnyNm = this.sendParam5.jvCpnyNm;
			this.setStateApcnSave_({
					key: 'erpSaleDd',
					value: convertNvl(this.erpSaleDd, '') == '' ? '' : this.$moment(this.erpSaleDd).format('YYYYMMDD')
				});
			this.setStateApcnSave_({ key: 'jvSaleDd',
					value: convertNvl(this.jvSaleDd, '') == '' ? '' : this.$moment(this.jvSaleDd).format('YYYYMMDD') });
			this.setStateApcnSave_({ key: 'jvCpnyNm',value: convertNvl(this.jvCpnyNm, '') });
			this.setStateApcnSave_({
					key: 'oemSaleDd',
					value: convertNvl(this.oemSaleDd, '') == '' ? '' : this.$moment(this.oemSaleDd).format('YYYYMMDD')
				});
	},
	watch: {
		sendParam5(newValue, oldValue) {
			//console.log('!23!!!!!!!!!!!!!!!>', this.sendParam5);
			//제품번호를 가지고 캠페인 리스트를 조회함 (Carsales팝업에서 조회를 해온다.)
			if (!this.currentCmpnCd && this.sendParam5.cmpnNoList != '') {
				this.carVin = ''; // Vin No
				this.pmcId = ''; //pmc 번호

				this.carTypeNm = '';

				this.custNm = ''; //판매사
				this.licensePlate = '';
				this.saleRegnNm = ''; //판매지역

				this.erpSaleDd = ''; //HTWO판매일

				this.milgPo = ''; //보증주행거리
				this.usePrdPo = ''; //보증사용기간

				this.wrntStrtDd = '';//품질보증 시작일
				this.wrntEndDd = '';//보증만료일

				this.flclSpcNm = ''; //연료전지사양
				this.oemSaleDd = ''; //고객판매일
				this.jvSaleDd = '';
				this.$sf_showMessage({
					icon: 'ok',
					message: this.getMessage_('QWCC001928') + ' [' + this.sendParam5.cmpnNoList + ']',
					closeFn: this.close
				});

				//return false;
			}
			//else {
			if(this.sendParam5.oemSaleDd!=null){
				this.carVin = this.sendParam5.carVin; // Vin No
				// this.pmcId = this.sendParam5.pmcId; //pmc 번호

				this.carTypeNm = this.sendParam5.carTypeNm;

				this.custNm = this.sendParam5.custNm; //판매사
				this.licensePlate = this.sendParam5.licensePlate;
				this.saleRegnNm = this.sendParam5.saleRegnNm; //판매지역

				this.oemSaleDd = this.sendParam5.oemSaleDd; //고객판매일

				this.milgPo = this.sendParam5.milg; //보증주행거리
				this.usePrdPo = this.sendParam5.usePrd; //보증사용기간

				this.wrntStrtDd = this.sendParam5.wrntStrtDd; //품질보증 시작일
				this.wrntEndDd = this.sendParam5.wrntEndDd; //보증만료일
			
			}else{
				this.carVin = ""; // Vin No

				this.carTypeNm = ""; //차종유형

				this.custNm = ""; //판매사
				this.licensePlate = "";
				this.saleRegnNm = ""; //판매지역
				this.oemSaleDd = ""; //고객판매일
				

				this.milgPo = ""; //보증주행거리
				this.usePrdPo = ""; //보증사용기간

				this.wrntStrtDd = '';//품질보증 시작일
				this.wrntEndDd = '';//보증만료일
			}

			this.pmcId = this.sendParam5.pmcId; //pmc 번호
			this.flclSpcNm = this.sendParam5.flclSpcNm; //연료전지사양
			this.oemSaleDd = this.sendParam5.oemSaleDd; //고객판매일

			this.erpSaleDd = this.sendParam5.erpSaleDd; //HTWO판매일
			this.jvSaleDd = this.sendParam5.jvSaleDd; 
			this.jvCpnyNm = this.sendParam5.jvCpnyNm;
			this.licensePlate = this.sendParam5.licensePlate;
			this.custNm = this.sendParam5.custNm;

			this.setStateRoApcnPopup_({ key: 'erpSaleDd', value: convertNvl(this.erpSaleDd, '') }); 
			this.setStateRoApcnPopup_({ key: 'oemSaleDd', value: convertNvl(this.oemSaleDd, '') }); //고객판매일
			// this.setStateApcnSave_({ key: 'jvSaleDd', value: convertNvl(this.jvSaleDd, '') }); //PMC ID
			this.setState_({ key: 'selectedPmcId', value: convertNvl(this.pmcId, '') }); //PMC ID




			this.setStateApcnSave_({
					key: 'erpSaleDd',
					value: convertNvl(this.erpSaleDd, '') == '' ? '' : this.$moment(this.erpSaleDd).format('YYYYMMDD')
				});
			this.setStateApcnSave_({ key: 'jvSaleDd',
					value: convertNvl(this.jvSaleDd, '') == '' ? '' : this.$moment(this.jvSaleDd).format('YYYYMMDD') });
			this.setStateApcnSave_({ key: 'jvCpnyNm',value: convertNvl(this.jvCpnyNm, '') });
			this.setStateApcnSave_({
					key: 'oemSaleDd',
					value: convertNvl(this.oemSaleDd, '') == '' ? '' : this.$moment(this.oemSaleDd).format('YYYYMMDD')
				});
			//}
		},
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'pmcId', value: convertNvl(this.pmcId, '') }); //PMC ID
				this.setStateApcnSave_({ key: 'vehlCd', value: convertNvl(this.vehlCd, '') }); //차종코드
				this.setStateApcnSave_({ key: 'carTypeNm', value: convertNvl(this.carTypeNm, '') }); //차종유형
				this.setStateApcnSave_({ key: 'custNm', value: convertNvl(this.custNm, '') }); //판매사
				this.setStateApcnSave_({ key: 'saleRegnNm', value: convertNvl(this.saleRegnNm, '') }); //판매지역
				this.setStateApcnSave_({
					key: 'erpSaleDd',
					value: convertNvl(this.erpSaleDd, '') == '' ? '' : this.$moment(this.erpSaleDd).format('YYYYMMDD')
				}); //HTWO판매일
				//this.setStateApcnSave_({ key: 'milg', value: convertNvl(this.milg, '') }); //보증주행거리
				this.setStateApcnSave_({ key: 'milgPo', value: convertNvl(this.milgPo, '') }); //보증주행거리
				this.setStateApcnSave_({ key: 'usePrdPo', value: convertNvl(this.usePrdPo, '') }); //보증사용기간
				this.setStateApcnSave_({ key: 'flclSpcNm', value: convertNvl(this.flclSpcNm, '') }); //연료전지사양
				this.setStateApcnSave_({
					key: 'oemSaleDd',
					value: convertNvl(this.oemSaleDd, '') == '' ? '' : this.$moment(this.oemSaleDd).format('YYYYMMDD')
				}); //고객판매일
				this.setStateApcnSave_({ key: 'jvSaleDd',
					value: convertNvl(this.jvSaleDd, '') == '' ? '' : this.$moment(this.jvSaleDd).format('YYYYMMDD') });
				this.setStateApcnSave_({
					key: 'wrntStrtDd',
					value: convertNvl(this.wrntStrtDd, '') == '' ? '' : this.$moment(this.wrntStrtDd).format('YYYYMMDD')
				});
				this.setStateApcnSave_({
					key: 'wrntEndDd',
					value: convertNvl(this.wrntEndDd, '') == '' ? '' : this.$moment(this.wrntEndDd).format('YYYYMMDD')
				});
				this.setStateApcnSave_({
					key: 'carVin',
					value: this.carVin
				});
				this.setStateApcnSave_({
					key: 'licensePlate',
					value: this.licensePlate
				});
			}
		},
		//삭제Flag
		isDelPwaCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelPwaCompInitFlag) {
				this.onPmcIdInuPutKeyDown();
			}
		},
		//삭제Flag
		isDelPwaCompInitFlag2() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelPwaCompInitFlag2) {
				this.onPmcIdInuPutKeyDown();
			}
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
